<template>
    <div>
        <div class="news" style="margin-top: 30px">
            <div class="main">
                <div class="swiper-container swiper">
                    <div v-if="bannerList.length" class="swiper-wrapper">
                        <div
                            class="swiper-slide"
                            v-for="(item, index) in bannerList"
                            :key="index"
                        >
                            <img
                                :src="item.image"
                                style="width: 100%; height: 480px"
                            />
                            <p class="swiper-title">
                                {{ item.title }}
                            </p>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
        <!-- 新闻动态/专题培训/培训信息 -->
        <div class="news">
            <div class="main" style="margin-top: 0; padding: 0 16px">
                <div class="left" style="width: 70%">
                    <div class="block">
                        <div class="dict-list">
                            <h6>新闻动态</h6>
                            <ul
                                style="
                                    display: flex;
                                    cursor: pointer;
                                    align-items: flex-end;
                                "
                                v-if="dynamicTypeList.length"
                            >
                                <li
                                    class="item"
                                    v-for="(itemType, index) in dynamicTypeList"
                                    :key="index"
                                    @mouseenter="handleDynamicType(itemType)"
                                    style="text-align: center"
                                >
                                    <span
                                        :class="[
                                            dynamicParams.dictId == itemType.id
                                                ? 'active'
                                                : '',
                                        ]"
                                        >{{ itemType.dictName }}</span
                                    >
                                </li>
                            </ul>
                        </div>
                        <a class="more" @click="handleMoreDynamic">更多>></a>
                    </div>
                    <div class="list" style="min-height: 273px">
                        <ul v-if="dynamicList.length">
                            <li
                                v-for="(item, index) in dynamicList"
                                :key="index"
                                class="item"
                                @click="detailNews(item)"
                            >
                                <a class="title">{{ item.title }}</a>
                                <span class="date" v-if="item.releaseTime">
                                    {{
                                        item.releaseTime.substring(0, 10)
                                    }}</span
                                >
                            </li>
                        </ul>
                        <div v-if="!dynamicList.length">
                            <Empty></Empty>
                        </div>
                    </div>

                    <div class="block">
                        <div class="dict-list">
                            <h6>培训信息</h6>
                            <!-- <ul
                style="display: flex; cursor: pointer; align-items: flex-end"
                v-if="noticeTypeList.length"
              >
                <li
                  class="item"
                  v-for="(itemType, index) in noticeTypeList"
                  :key="index"
                  @mouseenter="handleNoticeType(itemType)"
                  style="text-align: center"
                >
                  <span
                    :class="[
                      noticeParams.dictId == itemType.id ? 'active' : '',
                    ]"
                    >{{ itemType.dictName }}</span
                  >
                </li>
              </ul> -->
                        </div>
                        <a class="more" @click="handleMoreNotice">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="noticeList.length">
                            <li
                                v-for="(item, index) in noticeList"
                                :key="index"
                                class="item"
                                @click="detailNews(item)"
                            >
                                <a class="title"
                                    >{{ item.title }}
                                    <Tag
                                        @click.native="detailNews(item)"
                                        type="border"
                                        color="blue"
                                        v-if="item.enrollTag"
                                        >{{ item.enrollTag }}</Tag
                                    ></a
                                >

                                <span class="date" v-if="item.releaseTime">
                                    {{
                                        item.releaseTime.substring(0, 10)
                                    }}</span
                                >
                                <!-- <span class="date">{{ item.address }}</span> -->
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right" style="width: 30%">
                    <div class="block">
                        <h4 class="title but_title">专题培训</h4>
                        <!-- <a class="more" @click="handleProjectMore">更多>></a> -->
                    </div>
                    <div class="list vip-service">
                        <ul v-if="trainTypeList.length">
                            <li
                                v-for="(item, index) in trainTypeList"
                                :key="index"
                                class="ite"
                                @click="handleProject(item)"
                            >
                                <a class="title">
                                    <Icon
                                        :type="item.icon"
                                        style="font-size: 24px"
                                    ></Icon>
                                    {{ item.dictName }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- banner -->
        <div class="news">
            <div
                class="main"
                style="position: relative; padding-top: 30px; cursor: pointer"
                @click="handleStudy"
            >
                <!-- <img
                    src="../../static/image/ban.jpg"
                    alt=""
                    style="width: 100%; height: 160px"
                />
                <p
                    style="
                        position: absolute;
                        top: 80px;
                        left: 39%;
                        color: rgb(255, 255, 255);
                        font-size: 34px;
                        font-weight: 500;
                        letter-spacing: 3px;
                    "
                >
                    在线学习平台
                </p> -->

                <img
                    src="../../static/image/banner6.jpeg"
                    alt=""
                    style="width: 1200px"
                />
            </div>
        </div>

        <!-- 成果展示 -->
        <div class="news activity">
            <div class="main" style="padding: 0 16px">
                <div class="left" style="width: 100%">
                    <div class="block">
                        <h4 class="title but_title">成果展示</h4>
                        <a class="more" @click="handleActivityMore">更多>></a>
                    </div>
                    <div class="activity-list">
                        <ul v-if="activityList.length">
                            <li
                                v-for="(item, index) in activityList"
                                :key="index"
                                class="item"
                                @click="detailNews(item)"
                            >
                                <a>
                                    <img
                                        v-if="!item.image"
                                        src="../../static/image/1.jpg"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.image"
                                        :src="item.image"
                                        alt=""
                                    />
                                    <div class="activity-cont">
                                        <div class="activity-info">
                                            <h4 class="title">
                                                {{ item.title }}
                                            </h4>
                                            <p class="preview">
                                                {{ item.description }}
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getDict, getDictPageList } from "../api/dict";
import { getNewsList } from "../api/news.js";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import Empty from "../components/Empty.vue";
export default {
    components: {
        Empty,
    },
    data() {
        return {
            // 头图
            bannerList: [],
            bannerParams: {
                page: 1,
                pageSize: 10,
                status: "2",
                dictId: "",
            },
            bannerEmpty: false,
            bannerLoading: true,

            //新闻动态
            dynamicTypeList: [],
            dynamicParams: {
                page: 1,
                pageSize: 7,
                status: "2",
                dictId: "1",
                dictName: "",
            },
            dynamicList: [],
            //培训信息
            trainTypeList: [],
            trainParams: {
                page: 1,
                pageSize: 7,
                status: "2",
                dictId: "1",
                dictName: "",
            },
            trainList: [],

            iconList: [
                "ionic",
                "arrow-return-right",
                "shuffle",
                "flag",
                "crop",
                "paintbucket",
            ],

            //成果展示
            activityParams: {
                page: 1,
                pageSize: 8,
                status: "2",
                dictId: "1",
                dictName: "",
            },
            activityList: [],

            //培训信息
            noticeTypeList: [],
            noticeParams: {
                page: 1,
                pageSize: 7,
                status: "2",
                dictId: "1",
                dictName: "",
            },
            noticeList: [],
        };
    },
    created() {
        this.getDictBanner();
        this.getNoticeDict();
        this.getDynamicDict();
        this.getTrainDict();
        this.getActivityDict();
    },

    methods: {
        handleStudy() {
            window.open("https://bim.tccacc.com/#/index/home");
        },

        //专题培训
        handleProjectMore() {},

        handleProject(item) {
            let routeUrl = this.$router.resolve({
                path: "/index/ProjectList",
                query: {
                    id: item.id,
                },
            });
            window.open(routeUrl.href, "_blank");

            return;

            if (
                item.id == "1552553938815827969" ||
                item.id == "1602253905363800065"
            ) {
                window.open("https://www.tccacc.net/#/index/examChapter");
            } else {
                let routeUrl = this.$router.resolve({
                    path: "/index/ProjectList",
                    query: {
                        id: item.id,
                    },
                });
                window.open(routeUrl.href, "_blank");
            }
        },

        //新闻动态
        getDynamicDict() {
            let params = {
                page: 1,
                pageSize: 10,
                parentId: 2,
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.dynamicTypeList = res.data;
                    this.dynamicParams.dictId = this.dynamicTypeList[0].id;
                    this.dynamicParams.dictName =
                        this.dynamicTypeList[0].dictName;
                    this.getNewsDynamicList();
                }
            });
        },

        handleDynamicType(item) {
            this.dynamicParams.dictId = item.id;
            this.dynamicParams.dictName = item.dictName;
            this.getNewsDynamicList();
        },

        getNewsDynamicList() {
            getNewsList(this.dynamicParams).then((res) => {
                if (res.code == 200) {
                    this.dynamicList = res.data.records;
                }
            });
        },

        handleMoreDynamic() {
            let routeUrl = this.$router.resolve({
                path: "/index/DynamicList",
                query: {
                    activeName: this.dynamicParams.dictName,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        //培训信息
        getTrainDict() {
            let params = {
                parentId: "3",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.trainTypeList = res.data.slice(0,4);
                    this.trainTypeList.forEach((x, i) => {
                        this.$set(x, "icon", this.iconList[i]);
                    });
                    console.log('33',this.trainTypeList)
                    this.trainParams.dictId = this.trainTypeList[0].id;
                    this.trainParams.dictName = this.trainTypeList[0].dictName;
                    this.getNewsTrainList();
                }
            });
        },

        handleTrainType(item) {
            this.trainParams.dictId = item.id;
            this.trainParams.dictName = item.dictName;
            this.getNewsTrainList();
        },

        getNewsTrainList() {
            getNewsList(this.trainParams).then((res) => {
                if (res.code == 200) {
                    this.trainList = res.data.records;
                }
            });
        },

        handleMoreTrain() {
            let routeUrl = this.$router.resolve({
                path: "/index/TrainList",
                query: {
                    activeName: this.trainParams.dictName,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        //培训信息
        getNoticeDict() {
            let params = {
                parentId: "8",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.noticeTypeList = res.data;
                    this.noticeParams.dictId = this.noticeTypeList[0].id;
                    this.noticeParams.dictName =
                        this.noticeTypeList[0].dictName;
                    this.getNewsNoticeList();
                }
            });
        },

        handleNoticeType(item) {
            this.noticeParams.dictId = item.id;
            this.noticeParams.dictName = item.dictName;
            this.getNewsNoticeList();
        },

        getNewsNoticeList() {
            getNewsList(this.noticeParams).then((res) => {
                if (res.code == 200) {
                    this.noticeList = res.data.records;
                }
            });
        },

        handleMoreNotice() {
            let routeUrl = this.$router.resolve({
                path: "/index/TrainList",
                query: {
                    activeName: this.noticeParams.dictName,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        //成果展示
        getActivityDict() {
            let params = {
                parentId: "4",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.activityTypeList = res.data;
                    this.activityParams.dictId = this.activityTypeList[0].id;
                    this.activityParams.dictName =
                        this.activityTypeList[0].dictName;
                    this.getNewsActivityList();
                }
            });
        },

        getNewsActivityList() {
            getNewsList(this.activityParams).then((res) => {
                if (res.code == 200) {
                    this.activityList = res.data.records;
                }
            });
        },

        handleActivityMore() {
            let routeUrl = this.$router.resolve({
                path: "/index/ActivityList",
            });
            window.open(routeUrl.href, "_blank");
        },

        // 头图
        getDictBanner() {
            let params = {
                page: 1,
                pageSize: 10,
                parentId: 1,
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    this.bannerParams.dictId = res.data[0].id;
                    this.getBannerQuery();
                }
            });
        },

        getBannerQuery() {
            let params = {
                page: 1,
                pageSize: 10,
                parentId: 1,
            };
            getNewsList(params).then((res) => {
                if (res.code == 200) {
                    this.bannerList = res.data.records;
                    this.$nextTick(() => {
                        this.initSwiperBanner();
                    });
                    this.initSwiperBanner();
                }
            });
        },

        initSwiperBanner() {
            let that = this;
            let flag = false;
            setTimeout(() => {
                var mySwiper = new Swiper(".swiper", {
                    autoplay: 8000,
                    speed: 1000,
                    loop: true,
                    paginationClickable: true,
                    autoplayDisableOnInteraction: true,
                    grabCursor: true,
                    effect: "slide",
                    fadeEffect: {
                        crossFade: true,
                    },
                    observer: true,
                    observerParents: true,
                    observeSlideChildren: true,
                    pagination: ".swiper-pagination",
                    preventClicks: false,
                    preventClicksPropagation: false,

                    onTap: function (mySwiper, event) {
                        if (that.flag) {
                            return;
                        }
                        let i = mySwiper.activeIndex;
                        if (i > that.bannerList.length) {
                            i = 1;
                        }
                        let item = that.bannerList[i - 1];
                        if (item.url) {
                            window.open(item.url);
                        }
                        // if (!item.jumpUrl && item.content) {
                        //     let routeUrl = that.$router.resolve({
                        //         name: "BannerDetail",
                        //         query: {
                        //             id: item.id,
                        //         },
                        //     });
                        //     window.open(routeUrl.href, "_blank");
                        // }
                    },
                    onSlideChangeStart: function (mySwiper, event) {
                        // console.log("start");
                        that.flag = true;
                        setTimeout(() => {
                            that.flag = false;
                        }, 1500);
                    },
                    onSlideChangeEnd: function (mySwiper, event) {
                        // console.log("end");
                    },
                });

                //鼠标覆盖停止自动切换
                // mySwiper.container[0].onmouseover = function () {
                //     mySwiper.stopAutoplay();
                //     console.log("移入", mySwiper);
                // };
                // //鼠标移出开始自动切换
                // mySwiper.container[0].onmouseout = function () {
                //     console.log("移出", mySwiper);
                //     mySwiper.startAutoplay();
                // };
            }, 500);
        },

        detailNews(item) {
            switch (item.type) {
                case "1": {
                    window.open(item.url);
                    break;
                }
                case "2": {
                    let routeUrl = this.$router.resolve({
                        path: "/index/NewsDetail",
                        query: {
                            activeName: item.dictName,
                            id: item.id,
                        },
                    });
                    window.open(routeUrl.href, "_blank");
                    break;
                }
                case "3": {
                    window.open(item.fileUrl);
                    break;
                }
            }
        },
    },
};
</script>

<style>
@import "../assets/style.css";
@import "../assets/style-mob.css";
</style>

<style scoped>
.swiper2 {
    width: 12rem;
    padding-top: 0.4rem;
    padding-bottom: 0.2rem;
    overflow: hidden;
    margin: 0 auto;
}

.partner-img {
    width: 3.1rem;
    height: 0.58rem;
    display: block;
    margin: 0 auto;
}

.active {
    border-bottom: 2px solid #004b85 !important;
    color: #004b85;
    font-weight: bold;
}
</style>


<style>
.swiper-pagination-bullet-active {
    background: #306baf !important;
    opacity: 1 !important;
}

.swiper-button-prev {
    width: 19px !important;
    height: 19px !important;
    top: 82px;
    background: url(../../static/img/imgbtnl.png) !important;
}

.swiper-button-next {
    width: 19px !important;
    height: 19px !important;
    top: 82px;
    background: url(../../static/img/imgbtnr.png) !important;
}
</style>


// WEBPACK FOOTER //
// src/views/HomePage.vue